import { SalaryEntryQuery } from '../salary-entries/salary-entries.api';
import { prepaymentApi } from './prepayment.api';
import { CreatePrepaymentDto, UpdatePrepaymentDto } from '@sr/dto';

export const useAddPrepayment = () => {
  const [createPrepayment] = prepaymentApi.useCreatePrepaymentMutation();
  return async (dto: CreatePrepaymentDto) => {
    return createPrepayment(dto).unwrap();
  };
};

export const useUpdatePrepayment = () => {
  const [updatePrepayment] = prepaymentApi.useUpdatePrepaymentMutation();
  return async (dto: UpdatePrepaymentDto) => {
    return updatePrepayment(dto).unwrap();
  };
};

export const useDeletePrepayment = (qArg?: SalaryEntryQuery) => {
  const [callDelete] = prepaymentApi.useDeletePrepaymentMutation();
  const [callDeleteCahable] = prepaymentApi.useDeleteSalaryPrepaymentMutation();

  return async (salaryEntryId: number) => {
    if (qArg) 
      return callDeleteCahable({ entryId: salaryEntryId, ...qArg });
    else
      return callDelete(salaryEntryId).unwrap();
  };
};
